export default function getDisablePatients(payload) {
    return payload.map(({ id }) => ({
        id,
        data: {
            enable: false,
        },
    }));
}
